export default __webpack_public_path__ + "static/media/5c.906d2a94.svg";